import { saveAs } from 'file-saver';

// Download file from public folder
export const downloadFileFromAssets = async (fileName: string, displayName?: string) => {
  try {
    // Create the URL for the file in the public directory
    const fileUrl = `/${fileName}`;
    
    // Fetch the file
    const response = await fetch(fileUrl);
    
    if (!response.ok) {
      throw new Error(`File not found: ${fileName}`);
    }
    
    const blob = await response.blob();
    
    // Download with custom name or original name
    const downloadName = displayName || fileName;
    saveAs(blob, downloadName);
    
    return true;
  } catch (error) {
    console.error('Error downloading file:', error);
    throw new Error(`Failed to download ${fileName}`);
  }
};

// Download reconciliation format file
export const downloadReconciliationFormat = async () => {
  try {
    await downloadFileFromAssets('reconciliation-format.xlsx', 'Reconciliation_Format.xlsx');
    return true;
  } catch (error) {
    console.error('Error downloading reconciliation format:', error);
    throw error;
  }
};
